<span>
  <button mat-raised-button
    class="create-lesson__button"
    type="button"
    [routerLink]="['/teacher/prepare/new']"
    >+ Создать новое</button>
</span>
